import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=82feb29c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=82feb29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82feb29c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82feb29c')) {
      api.createRecord('82feb29c', component.options)
    } else {
      api.reload('82feb29c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=82feb29c&scoped=true&", function () {
      api.rerender('82feb29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20E113LHZtKiR/JS/comp/PopupBox.vue"
export default component.exports